(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8553],{

/***/ 4022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _StorylinerImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4090);
// import node_modules



// import components

// define components
var MarkdownImage = function(param) {
    var height = param.height, hasShadow = param.hasShadow, imageId = param.imageId, title = param.title, width = param.width;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "storyliner-markdown-image",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_StorylinerImage__WEBPACK_IMPORTED_MODULE_2__["default"], {
            hasShadow: hasShadow,
            height: height,
            imageId: imageId,
            title: title,
            width: width
        })
    });
};
MarkdownImage.defaultProps = {
    hasShadow: false
};
MarkdownImage.propTypes = {
    hasShadow: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    height: prop_types__WEBPACK_IMPORTED_MODULE_3__.number.isRequired,
    imageId: prop_types__WEBPACK_IMPORTED_MODULE_3__.string.isRequired,
    title: prop_types__WEBPACK_IMPORTED_MODULE_3__.string.isRequired,
    width: prop_types__WEBPACK_IMPORTED_MODULE_3__.number.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (MarkdownImage);


/***/ }),

/***/ 97:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _MarkdownLink_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5676);
/* harmony import */ var _MarkdownLink_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_MarkdownLink_module_css__WEBPACK_IMPORTED_MODULE_3__);
// import node_modules




// import types

// define component
var MarkdownLink = function(param) {
    var children = param.children, href = param.href;
    // storyliner link
    if (href === null || href === void 0 ? void 0 : href.includes("https://storylinerlabs.com")) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            className: (_MarkdownLink_module_css__WEBPACK_IMPORTED_MODULE_3___default().link),
            href: href.replace("https://storylinerlabs.com", ""),
            passHref: true,
            children: children
        });
    }
    // external link
    if ((href === null || href === void 0 ? void 0 : href.includes("http")) || (href === null || href === void 0 ? void 0 : href.includes("mailto"))) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: href,
            rel: "noopener noreferrer",
            target: "_blank",
            children: children
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            children: children
        })
    });
};
MarkdownLink.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_4__.node.isRequired,
    href: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (MarkdownLink);


/***/ }),

/***/ 7965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ atoms_RemoteMarkdown; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@storylinerlabs/design/dist/design.esm.js + 119 modules
var design_esm = __webpack_require__(4468);
// EXTERNAL MODULE: ./node_modules/next-mdx-remote/dist/index.js + 1 modules
var dist = __webpack_require__(3899);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 3 modules
var useTranslation = __webpack_require__(7058);
// EXTERNAL MODULE: ./src/components/atoms/ClickToTweet.module.css
var ClickToTweet_module = __webpack_require__(2097);
var ClickToTweet_module_default = /*#__PURE__*/__webpack_require__.n(ClickToTweet_module);
;// CONCATENATED MODULE: ./src/components/atoms/ClickToTweet.tsx
// import node_modules




// import styles

// define component
var ClickToTweet = function(param) {
    var text = param.text, url = param.url;
    // init hooks
    var t = (0,useTranslation/* useTranslation */.$)("components").t;
    // render
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ClickToTweet_module_default()).container,
        children: [
            text,
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: (ClickToTweet_module_default()).link,
                href: "https://twitter.com/intent/tweet?text=".concat(encodeURIComponent(text), "%0A%0A").concat(url),
                rel: "noopener noreferrer",
                target: "_blank",
                children: t("ClickToTweet.link.label")
            })
        ]
    });
};
ClickToTweet.propTypes = {
    text: prop_types.string.isRequired,
    url: prop_types.string.isRequired
};
/* harmony default export */ var atoms_ClickToTweet = (ClickToTweet);

;// CONCATENATED MODULE: ./src/components/atoms/HtmlInMdx.tsx
// import node_modules



// define component
var HtmlInMdx = function(param) {
    var html = param.html;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        dangerouslySetInnerHTML: {
            __html: html
        }
    });
};
HtmlInMdx.propTypes = {
    html: prop_types.string.isRequired
};
/* harmony default export */ var atoms_HtmlInMdx = (HtmlInMdx);

// EXTERNAL MODULE: ./src/components/atoms/LinkComponent.tsx
var LinkComponent = __webpack_require__(2964);
// EXTERNAL MODULE: ./src/components/atoms/MarkdownImage.tsx
var MarkdownImage = __webpack_require__(4022);
// EXTERNAL MODULE: ./src/components/atoms/MarkdownLink.tsx
var MarkdownLink = __webpack_require__(97);
// EXTERNAL MODULE: ./src/components/atoms/PromoBox.module.css
var PromoBox_module = __webpack_require__(3414);
var PromoBox_module_default = /*#__PURE__*/__webpack_require__.n(PromoBox_module);
;// CONCATENATED MODULE: ./src/components/atoms/PromoBox.tsx
// import node_modules



// import styles

// define component
var PromoBox = function(param) {
    var html = param.html;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (PromoBox_module_default()).box,
        dangerouslySetInnerHTML: {
            __html: html
        }
    });
};
PromoBox.propTypes = {
    html: prop_types.string.isRequired
};
/* harmony default export */ var atoms_PromoBox = (PromoBox);

// EXTERNAL MODULE: ./src/components/atoms/Markdown.module.css
var Markdown_module = __webpack_require__(7310);
var Markdown_module_default = /*#__PURE__*/__webpack_require__.n(Markdown_module);
;// CONCATENATED MODULE: ./src/components/atoms/RemoteMarkdown.tsx
// import node_modules






// import components






// import styles

// define component
var RemoteMarkdown = function(param) {
    var content = param.content;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Markdown_module_default()).markdown,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* MDXRemote */.R, (0,_object_spread/* default */.Z)({
            components: {
                Button: design_esm/* Button */.zx,
                ClickToTweet: atoms_ClickToTweet,
                HtmlInMdx: atoms_HtmlInMdx,
                LinkButton: design_esm/* LinkButton */.Qj,
                LinkComponent: LinkComponent["default"],
                PromoBox: atoms_PromoBox,
                StorylinerImage: MarkdownImage/* default */.Z,
                a: MarkdownLink/* default */.Z
            }
        }, content))
    });
};
RemoteMarkdown.propTypes = {
    content: prop_types.shape({
        compiledSource: prop_types.string.isRequired
    }).isRequired
};
/* harmony default export */ var atoms_RemoteMarkdown = (RemoteMarkdown);


/***/ }),

/***/ 4090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "StorylinerImage": function() { return /* binding */ StorylinerImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var striptags__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3726);
/* harmony import */ var striptags__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(striptags__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2848);
/* harmony import */ var _StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5__);
/* eslint-disable react/jsx-props-no-spreading */ // import node_modules






// import styles

// Define component
var StorylinerImage = function(param) {
    var className = param.className, hasShadow = param.hasShadow, hasWhiteBg = param.hasWhiteBg, height = param.height, imageId = param.imageId, isBlack = param.isBlack, isRounded = param.isRounded, isWhite = param.isWhite, title = param.title, width = param.width;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default().image), isBlack && (_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default()["is-black"]), isWhite && (_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default()["is-white"]), isRounded && (_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default()["is-rounded"]), hasShadow && (_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default()["has-shadow"]), hasWhiteBg && (_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default()["white-bg"])),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default()), {
            alt: striptags__WEBPACK_IMPORTED_MODULE_4___default()(title),
            className: className,
            height: height,
            layout: "responsive",
            loading: "lazy",
            src: imageId,
            title: striptags__WEBPACK_IMPORTED_MODULE_4___default()(title),
            width: width
        })
    });
};
StorylinerImage.defaultProps = {
    className: undefined,
    hasShadow: undefined,
    hasWhiteBg: undefined,
    isBlack: false,
    isRounded: true,
    isWhite: false
};
StorylinerImage.propTypes = {
    className: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    hasShadow: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    hasWhiteBg: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    height: prop_types__WEBPACK_IMPORTED_MODULE_6__.number.isRequired,
    imageId: prop_types__WEBPACK_IMPORTED_MODULE_6__.string.isRequired,
    isBlack: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    isRounded: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    isWhite: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    title: prop_types__WEBPACK_IMPORTED_MODULE_6__.string.isRequired,
    width: prop_types__WEBPACK_IMPORTED_MODULE_6__.number.isRequired
};
/* harmony default export */ __webpack_exports__["default"] = (StorylinerImage);


/***/ }),

/***/ 3192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(603);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4468);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7058);
/* harmony import */ var jotai_immer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8387);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6198);
/* harmony import */ var _atoms_Section__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9748);
/* harmony import */ var _modules_jotai__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1262);
/* harmony import */ var _EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4370);
/* harmony import */ var _EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9__);
// import node_modules







// import types

// import components

// import modules

// import styles

// define component
var EarlyAccessSection = function(param) {
    var bgColor = param.bgColor;
    // init hooks
    var _useImmerAtom = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,jotai_immer__WEBPACK_IMPORTED_MODULE_7__/* .useImmerAtom */ .It)(_modules_jotai__WEBPACK_IMPORTED_MODULE_5__/* .earlyAccessModalAtom */ .KR), 2), setEarlyAccessModalState = _useImmerAtom[1];
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_8__/* .useTranslation */ .$)("components").t;
    // init func
    var onOpenModal = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(function() {
        setEarlyAccessModalState(function() {
            return true;
        });
    }, [
        setEarlyAccessModalState
    ]);
    // render section
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
        bgColor: bgColor,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9___default()["storyliner-early-access-section"]),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9___default()["storyliner-early-access-section-header"]),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6, {
                            alignment: "center",
                            isHyphenated: false,
                            tag: "h2",
                            children: t("EarlyAccessSection.title")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                            alignment: "center",
                            children: t("EarlyAccessSection.intro")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9___default()["storyliner-early-access-button"]),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
                            color: "dark",
                            text: t("EarlyAccessSection.callToAction.label"),
                            size: "large",
                            onClick: onOpenModal
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9___default()["storyliner-early-access-scribble"])
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9___default()["storyliner-early-access-section-helptext-container"]),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                        alignment: "center",
                        isHelpText: true,
                        size: "small",
                        children: t("EarlyAccessSection.creditCard")
                    })
                })
            ]
        })
    });
};
EarlyAccessSection.defaultProps = {
    bgColor: "white"
};
EarlyAccessSection.propTypes = {
    bgColor: prop_types__WEBPACK_IMPORTED_MODULE_10__.oneOf(Object.values(_types__WEBPACK_IMPORTED_MODULE_3__/* .SectionColorEnum */ .TJ))
};
/* harmony default export */ __webpack_exports__["default"] = (EarlyAccessSection);


/***/ }),

/***/ 6139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(603);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(655);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4468);
/* harmony import */ var use_immer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(57);
/* harmony import */ var jotai_immer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8387);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7058);
/* harmony import */ var _storylinerlabs_notifications__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1663);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6198);
/* harmony import */ var _modules_jotai__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1262);
/* harmony import */ var _modules_utils__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(3733);
/* harmony import */ var _ProductUpdatesForm_module_css__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(9061);
/* harmony import */ var _ProductUpdatesForm_module_css__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_ProductUpdatesForm_module_css__WEBPACK_IMPORTED_MODULE_14__);
// import node_modules











// import types

// import modules


// import styles

// ProductUpdatesForm component
var ProductUpdatesForm = function() {
    // init state
    var _useImmer = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,use_immer__WEBPACK_IMPORTED_MODULE_8__/* .useImmer */ .x)(""), 2), inputState = _useImmer[0], setInputState = _useImmer[1];
    var _useImmer1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,use_immer__WEBPACK_IMPORTED_MODULE_8__/* .useImmer */ .x)(null), 2), errorState = _useImmer1[0], setErrorState = _useImmer1[1];
    var _useImmer2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,use_immer__WEBPACK_IMPORTED_MODULE_8__/* .useImmer */ .x)(false), 2), loadingState = _useImmer2[0], setLoadingState = _useImmer2[1];
    // init hooks
    var _useImmerAtom = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,jotai_immer__WEBPACK_IMPORTED_MODULE_9__/* .useImmerAtom */ .It)(_modules_jotai__WEBPACK_IMPORTED_MODULE_6__/* .localeAtom */ .S$), 1), locale = _useImmerAtom[0];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_10__/* .useTranslation */ .$)("components").t;
    var subscribeToProductUpdatesWithDoubleOptin = (0,_storylinerlabs_notifications__WEBPACK_IMPORTED_MODULE_4__/* .useNotifications */ .z)().subscribeToProductUpdatesWithDoubleOptin;
    // define methods
    var onChange = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(function(event) {
        setInputState(event.target.value);
    }, [
        setInputState
    ]);
    var onSubmit = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function(event) {
            var _ref, error, success, isDE, thankYouPage, error1;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        // show spinner
                        setLoadingState(true);
                        // check email
                        if (!(0,_modules_utils__WEBPACK_IMPORTED_MODULE_13__/* .isEmail */ .J)(inputState)) {
                            setErrorState(t("ProductUpdatesForm.email.error"));
                            setLoadingState(false);
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        // reset error
                        setErrorState(null);
                        return [
                            4,
                            subscribeToProductUpdatesWithDoubleOptin({
                                email: inputState,
                                locale: locale
                            })
                        ];
                    case 2:
                        _ref = _state.sent(), error = _ref.error, success = _ref.success;
                        // check error
                        if (error || !success) {
                            throw new Error("Subscription failed!");
                        }
                        isDE = locale === "de";
                        thankYouPage = isDE ? _types__WEBPACK_IMPORTED_MODULE_5__/* .RouteEnum.WEBSITE_NEWSLETTER_THANK_YOU_DE */ .gv.WEBSITE_NEWSLETTER_THANK_YOU_DE : _types__WEBPACK_IMPORTED_MODULE_5__/* .RouteEnum.WEBSITE_NEWSLETTER_THANK_YOU_EN */ .gv.WEBSITE_NEWSLETTER_THANK_YOU_EN;
                        router.push(thankYouPage);
                        // hide spinner and close modal
                        setLoadingState(false);
                        setInputState("");
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error1 = _state.sent();
                        setErrorState(t("ProductUpdatesForm.submit.error"));
                        setLoadingState(false);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }(), [
        inputState,
        locale,
        router,
        setErrorState,
        setInputState,
        setLoadingState,
        subscribeToProductUpdatesWithDoubleOptin,
        t
    ]);
    var onKeyDown = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(function(event) {
        // handle return
        if (event.key === "Enter") {
            event.preventDefault();
            onSubmit(event);
        }
    }, [
        onSubmit
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_ProductUpdatesForm_module_css__WEBPACK_IMPORTED_MODULE_14___default().container),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_ProductUpdatesForm_module_css__WEBPACK_IMPORTED_MODULE_14___default()["form-container"]),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Form */ .l0, {
                    formId: "storyliner-newsletter-form",
                    onSubmit: onSubmit,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_ProductUpdatesForm_module_css__WEBPACK_IMPORTED_MODULE_14___default()["input-container"]),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Input */ .II, {
                                    customInputClasses: (_ProductUpdatesForm_module_css__WEBPACK_IMPORTED_MODULE_14___default().input),
                                    customLabelClasses: (_ProductUpdatesForm_module_css__WEBPACK_IMPORTED_MODULE_14___default().label),
                                    formId: "storyliner-product-updates-form",
                                    inputId: "storyliner-product-updates-form-intput",
                                    inputName: "storyliner-product-updates-form-intput",
                                    onChange: onChange,
                                    onKeyDown: onKeyDown,
                                    placeholder: t("ProductUpdatesForm.email.placeholder"),
                                    type: "email",
                                    value: inputState
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
                                    color: "dark",
                                    customClasses: (_ProductUpdatesForm_module_css__WEBPACK_IMPORTED_MODULE_14___default().button),
                                    formId: "storyliner-newsletter-form",
                                    isLoading: loadingState,
                                    size: "large",
                                    text: t("ProductUpdatesForm.submit.label"),
                                    type: "submit"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_ProductUpdatesForm_module_css__WEBPACK_IMPORTED_MODULE_14___default()["error-container"]),
                            children: errorState && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                isError: true,
                                children: errorState
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_ProductUpdatesForm_module_css__WEBPACK_IMPORTED_MODULE_14___default()["legal-container"]),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .RemixIcon */ .zS, {
                        customClasses: (_ProductUpdatesForm_module_css__WEBPACK_IMPORTED_MODULE_14___default()["legal-icon"]),
                        iconName: "ri-lock-line"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Tooltip */ .u, {
                        placement: "top",
                        content: t("ProductUpdatesForm.privacy.tooltip"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                            size: "small",
                            isHelpText: true,
                            children: t("ProductUpdatesForm.privacy.text")
                        })
                    })
                ]
            })
        ]
    });
};
ProductUpdatesForm.displayName = "ProductUpdatesForm";
/* harmony default export */ __webpack_exports__["Z"] = (ProductUpdatesForm);


/***/ }),

/***/ 8553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ templates_ReleaseNotesTemplate; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@storylinerlabs/design/dist/design.esm.js + 119 modules
var design_esm = __webpack_require__(4468);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 3 modules
var useTranslation = __webpack_require__(7058);
// EXTERNAL MODULE: ./src/types/index.ts + 5 modules
var types = __webpack_require__(6198);
// EXTERNAL MODULE: ./src/components/atoms/Column.tsx
var Column = __webpack_require__(4992);
// EXTERNAL MODULE: ./src/components/elements/EarlyAccessSection.tsx
var EarlyAccessSection = __webpack_require__(3192);
// EXTERNAL MODULE: ./src/components/layouts/MainLayout.tsx + 5 modules
var MainLayout = __webpack_require__(6880);
// EXTERNAL MODULE: ./src/components/forms/ProductUpdatesForm.tsx
var ProductUpdatesForm = __webpack_require__(6139);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 5 modules
var _sliced_to_array = __webpack_require__(603);
// EXTERNAL MODULE: ./node_modules/jotai-immer/dist/index.modern.js + 1 modules
var index_modern = __webpack_require__(8387);
// EXTERNAL MODULE: ./src/components/atoms/RemoteMarkdown.tsx + 3 modules
var RemoteMarkdown = __webpack_require__(7965);
// EXTERNAL MODULE: ./src/components/atoms/LinkComponent.tsx
var LinkComponent = __webpack_require__(2964);
// EXTERNAL MODULE: ./src/modules/jotai/index.ts + 1 modules
var jotai = __webpack_require__(1262);
// EXTERNAL MODULE: ./src/components/elements/ReleaseNote.module.css
var ReleaseNote_module = __webpack_require__(8834);
var ReleaseNote_module_default = /*#__PURE__*/__webpack_require__.n(ReleaseNote_module);
;// CONCATENATED MODULE: ./src/components/elements/ReleaseNote.tsx
// import node_modules








// import components


// import modules

// import styles

// define component
var ReleaseNote = function(param) {
    var releaseNote = param.releaseNote;
    // init hooks
    var _useImmerAtom = (0,_sliced_to_array/* default */.Z)((0,index_modern/* useImmerAtom */.It)(jotai/* localeAtom */.S$), 1), locale = _useImmerAtom[0];
    var t = (0,useTranslation/* useTranslation */.$)("components").t;
    // define methods
    var onSerializeDate = react.useCallback(function(contenfulDate) {
        var options = {
            year: "numeric",
            month: "long",
            day: "numeric"
        };
        var date = new Date(contenfulDate);
        var dateLocale = locale === "de" ? "de-DE" : "en-US";
        return date === null || date === void 0 ? void 0 : date.toLocaleDateString(dateLocale, options);
    }, [
        locale
    ]);
    // init vars
    var link = locale === "de" ? "/de/changelog/".concat(releaseNote.slug, "/") : "/changelog/".concat(releaseNote.slug, "/");
    var title = "#".concat(t("ReleaseNotes.app.".concat(releaseNote.app)), " #").concat(t("ReleaseNotes.category.".concat(releaseNote.category)));
    // render
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ReleaseNote_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ReleaseNote_module_default()).date,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComponent["default"], {
                    href: link,
                    children: onSerializeDate(releaseNote.pubDate)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ReleaseNote_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Heading */.X6, {
                        tag: "label",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Spacer */.LZ, {
                        height: "8px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Heading */.X6, {
                        tag: "h3",
                        children: releaseNote.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoteMarkdown/* default */.Z, {
                        content: releaseNote === null || releaseNote === void 0 ? void 0 : releaseNote.content
                    })
                ]
            })
        ]
    }, releaseNote.pubDate);
};
ReleaseNote.propTypes = {
    releaseNote: prop_types.shape({
        app: prop_types.oneOf(Object.values(types/* ReleaseNoteAppTypeEnum */.W)).isRequired,
        category: prop_types.oneOf(Object.values(types/* ReleaseNoteCategoryEnum */.uX)).isRequired,
        content: prop_types.shape({
            compiledSource: prop_types.string.isRequired
        }).isRequired,
        ctaLink: prop_types.string,
        ctaText: prop_types.string,
        pubDate: prop_types.string.isRequired,
        slug: prop_types.string.isRequired,
        title: prop_types.string.isRequired,
        type: prop_types.string.isRequired
    }).isRequired
};
ReleaseNote.displayName = "ReleaseNote";
/* harmony default export */ var elements_ReleaseNote = (ReleaseNote);

// EXTERNAL MODULE: ./src/components/lists/ReleaseNotesList.module.css
var ReleaseNotesList_module = __webpack_require__(7525);
var ReleaseNotesList_module_default = /*#__PURE__*/__webpack_require__.n(ReleaseNotesList_module);
;// CONCATENATED MODULE: ./src/components/lists/ReleaseNotesList.tsx
// import node_modules




// import components

// import styles

// define components
var ReleaseNotes = function(param) {
    var releaseNotes = param.releaseNotes;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (ReleaseNotesList_module_default()).list,
        children: releaseNotes.map(function(releaseNote) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(elements_ReleaseNote, {
                releaseNote: releaseNote
            }, releaseNote.title);
        })
    });
};
ReleaseNotes.propTypes = {
    releaseNotes: prop_types.arrayOf(prop_types.shape({
        app: prop_types.oneOf(Object.values(types/* ReleaseNoteAppTypeEnum */.W)).isRequired,
        category: prop_types.oneOf(Object.values(types/* ReleaseNoteCategoryEnum */.uX)).isRequired,
        content: prop_types.shape({
            compiledSource: prop_types.string.isRequired
        }).isRequired,
        ctaLink: prop_types.string,
        ctaText: prop_types.string,
        pubDate: prop_types.string.isRequired,
        slug: prop_types.string.isRequired,
        title: prop_types.string.isRequired,
        type: prop_types.string.isRequired
    }).isRequired).isRequired
};
ReleaseNotes.displayName = "ReleaseNotes";
/* harmony default export */ var ReleaseNotesList = (ReleaseNotes);

// EXTERNAL MODULE: ./src/components/meta/SEO.tsx
var SEO = __webpack_require__(8897);
// EXTERNAL MODULE: ./src/components/atoms/Section.tsx
var Section = __webpack_require__(9748);
;// CONCATENATED MODULE: ./src/components/templates/ReleaseNotesTemplate.tsx
// import node_modules






// import component







// define page
var ReleaseNotesTemplate = function(param) {
    var hrefLang = param.hrefLang, releaseNotes = param.releaseNotes;
    // init hooks
    var t = (0,useTranslation/* useTranslation */.$)("release-notes").t;
    // init render
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                description: t("seo.description"),
                hrefLang: hrefLang,
                image: t("seo.image"),
                title: t("seo.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainLayout/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* default */.ZP, {
                        bgColor: "desertStorm",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Spacer */.LZ, {
                                height: "64px"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Spacer */.LZ, {
                                mobileHeight: "25px",
                                tabletHeight: "25px",
                                height: "75px"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.ZP, {
                        bgColor: "desertStorm",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* default */.Z, {
                            cols: "md",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Heading */.X6, {
                                    alignment: "center",
                                    tag: "h1",
                                    children: t("hero.title")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Text */.xv, {
                                    alignment: "center",
                                    size: "large",
                                    children: t("hero.intro")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductUpdatesForm/* default */.Z, {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.ZP, {
                        bgColor: "desertStorm",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Spacer */.LZ, {
                            mobileHeight: "25px",
                            tabletHeight: "25px",
                            height: "75px"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReleaseNotesList, {
                        releaseNotes: releaseNotes
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.ZP, {
                        bgColor: "anakiwa",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Spacer */.LZ, {
                            mobileHeight: "25px",
                            tabletHeight: "50px",
                            height: "75px"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EarlyAccessSection["default"], {
                        bgColor: "anakiwa"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.ZP, {
                        bgColor: "anakiwa",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Spacer */.LZ, {
                            mobileHeight: "25px",
                            tabletHeight: "50px",
                            height: "75px"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.ZP, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Spacer */.LZ, {
                            height: "50px"
                        })
                    })
                ]
            })
        ]
    });
};
ReleaseNotesTemplate.propTypes = {
    hrefLang: prop_types.string.isRequired,
    releaseNotes: prop_types.arrayOf(prop_types.shape({
        app: prop_types.oneOf(Object.values(types/* ReleaseNoteAppTypeEnum */.W)).isRequired,
        category: prop_types.oneOf(Object.values(types/* ReleaseNoteCategoryEnum */.uX)).isRequired,
        content: prop_types.shape({
            compiledSource: prop_types.string.isRequired
        }).isRequired,
        ctaLink: prop_types.string,
        ctaText: prop_types.string,
        pubDate: prop_types.string.isRequired,
        slug: prop_types.string.isRequired,
        title: prop_types.string.isRequired,
        type: prop_types.string.isRequired
    }).isRequired).isRequired
};
/* harmony default export */ var templates_ReleaseNotesTemplate = (ReleaseNotesTemplate);


/***/ }),

/***/ 2097:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"storyliner-NB3vy8","link":"storyliner-iuImxc"};

/***/ }),

/***/ 7310:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"markdown":"storyliner-l9a5zk","storyliner-markdown-button":"storyliner-5WQeFL","storyliner-markdown-image":"storyliner-0CMuRb","responsive-iframe":"storyliner-MQtvxX","iframe-wrapper":"storyliner-s6HK1y","optin-canvas":"storyliner-xzbQ5J","info-text":"storyliner-xynJAU","icon-wrapper":"storyliner-HYoR1F","optin-button":"storyliner-0o3hOL"};

/***/ }),

/***/ 5676:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"storyliner-ttPbzh"};

/***/ }),

/***/ 3414:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"box":"storyliner-Bg3YeO"};

/***/ }),

/***/ 2848:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"storyliner-vbD9mK","fade-in":"storyliner-eNwawO","is-rounded":"storyliner-kV1a7W","is-white":"storyliner-FVEYZh","is-black":"storyliner-dc3Q7B","has-shadow":"storyliner-QcsozF","white-bg":"storyliner-bi4CsT"};

/***/ }),

/***/ 4370:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"storyliner-early-access-section":"storyliner-wwGQfR","storyliner-early-access-section-header":"storyliner-idzssv","storyliner-early-access-button":"storyliner-oIUwVo","storyliner-early-access-scribble":"storyliner-gRgBcx","storyliner-early-access-section-helptext-container":"storyliner-VU7xmS"};

/***/ }),

/***/ 8834:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"storyliner-Toxp1r","date":"storyliner-1vCIQA","content":"storyliner-LKLJBm"};

/***/ }),

/***/ 9061:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"input-container":"storyliner-Zuq2WH","error-container":"storyliner-Bax0Dv","form-container":"storyliner-JHpMX7","legal-container":"storyliner-pbZ6UF","legal-icon":"storyliner-1T3Eby","container":"storyliner-ZVZ3zl","input":"storyliner-oX50Yz","label":"storyliner-Fi7kYu","button":"storyliner-xXv0uP"};

/***/ }),

/***/ 7525:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"list":"storyliner-RT2pau"};

/***/ }),

/***/ 2746:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Allow jsx-runtime to be successfully imported from either React 17 or React 18.
 *
 * Inspired by the approach here: https://github.com/contentlayerdev/contentlayer/blob/main/packages/next-contentlayer/src/hooks/jsx-runtime.cjs
 */
const jsxRuntime = __webpack_require__(5893)

module.exports.c = jsxRuntime


/***/ }),

/***/ 1151:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NF": function() { return /* binding */ withMDXComponents; },
/* harmony export */   "Zo": function() { return /* binding */ MDXProvider; },
/* harmony export */   "ah": function() { return /* binding */ useMDXComponents; },
/* harmony export */   "pC": function() { return /* binding */ MDXContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('mdx/types').MDXComponents} Components
 *
 * @typedef Props
 *   Configuration.
 * @property {Components} [components]
 *   Mapping of names for JSX components to React components.
 * @property {boolean} [disableParentContext=false]
 *   Turn off outer component context.
 * @property {ReactNode} [children]
 *   Children.
 *
 * @callback MergeComponents
 * @param {Components} currentComponents
 *   Current components from the context.
 * @returns {Components}
 *   Merged components.
 */



/**
 * @type {import('react').Context<Components>}
 * @deprecated
 *   This export is marked as a legacy feature.
 *   That means it’s no longer recommended for use as it might be removed
 *   in a future major release.
 *
 *   Please use `useMDXComponents` to get context based components and
 *   `MDXProvider` to set context based components instead.
 */
const MDXContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({})

/**
 * @param {import('react').ComponentType<any>} Component
 * @deprecated
 *   This export is marked as a legacy feature.
 *   That means it’s no longer recommended for use as it might be removed
 *   in a future major release.
 *
 *   Please use `useMDXComponents` to get context based components instead.
 */
function withMDXComponents(Component) {
  return boundMDXComponent

  /**
   * @param {Record<string, unknown> & {components?: Components}} props
   * @returns {JSX.Element}
   */
  function boundMDXComponent(props) {
    const allComponents = useMDXComponents(props.components)
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, {...props, allComponents})
  }
}

/**
 * Get current components from the MDX Context.
 *
 * @param {Components|MergeComponents} [components]
 *   Additional components to use or a function that takes the current
 *   components and filters/merges/changes them.
 * @returns {Components}
 *   Current components.
 */
function useMDXComponents(components) {
  const contextComponents = react__WEBPACK_IMPORTED_MODULE_0__.useContext(MDXContext)
  // Memoize to avoid unnecessary top-level context changes
  return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    // Custom merge via a function prop
    if (typeof components === 'function') {
      return components(contextComponents)
    }

    return {...contextComponents, ...components}
  }, [contextComponents, components])
}

/** @type {Components} */
const emptyObject = {}

/**
 * Provider for MDX context
 *
 * @param {Props} props
 * @returns {JSX.Element}
 */
function MDXProvider({components, children, disableParentContext}) {
  let allComponents = useMDXComponents(components)

  if (disableParentContext) {
    allComponents = components || emptyObject
  }

  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    MDXContext.Provider,
    {value: allComponents},
    children
  )
}


/***/ }),

/***/ 3899:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R": function() { return /* binding */ MDXRemote; }
});

// NAMESPACE OBJECT: ./node_modules/@mdx-js/react/index.js
var _mdx_js_react_namespaceObject = {};
__webpack_require__.r(_mdx_js_react_namespaceObject);
__webpack_require__.d(_mdx_js_react_namespaceObject, {
  "MDXContext": function() { return lib/* MDXContext */.pC; },
  "MDXProvider": function() { return lib/* MDXProvider */.Zo; },
  "useMDXComponents": function() { return lib/* useMDXComponents */.ah; },
  "withMDXComponents": function() { return lib/* withMDXComponents */.NF; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next-mdx-remote/dist/jsx-runtime.cjs
var jsx_runtime = __webpack_require__(2746);
// EXTERNAL MODULE: ./node_modules/@mdx-js/react/lib/index.js
var lib = __webpack_require__(1151);
;// CONCATENATED MODULE: ./node_modules/@mdx-js/react/index.js


;// CONCATENATED MODULE: ./node_modules/next-mdx-remote/dist/index.js




if (typeof window !== 'undefined') {
  window.requestIdleCallback =
    window.requestIdleCallback ||
    function (cb) {
      var start = Date.now();
      return setTimeout(function () {
        cb({
          didTimeout: false,
          timeRemaining: function () {
            return Math.max(0, 50 - (Date.now() - start))
          },
        });
      }, 1)
    };

  window.cancelIdleCallback =
    window.cancelIdleCallback ||
    function (id) {
      clearTimeout(id);
    };
}

/**
 * Renders compiled source from next-mdx-remote/serialize.
 */
function MDXRemote({ compiledSource, frontmatter, scope, components = {}, lazy, }) {
    const [isReadyToRender, setIsReadyToRender] = (0,react.useState)(!lazy || typeof window === 'undefined');
    // if we're on the client side and `lazy` is set to true, we hydrate the
    // mdx content inside requestIdleCallback, allowing the page to get to
    // interactive quicker, but the mdx content to hydrate slower.
    (0,react.useEffect)(() => {
        if (lazy) {
            const handle = window.requestIdleCallback(() => {
                setIsReadyToRender(true);
            });
            return () => window.cancelIdleCallback(handle);
        }
    }, []);
    const Content = (0,react.useMemo)(() => {
        // if we're ready to render, we can assemble the component tree and let React do its thing
        // first we set up the scope which has to include the mdx custom
        // create element function as well as any components we're using
        const fullScope = Object.assign({ opts: { ..._mdx_js_react_namespaceObject, ...jsx_runtime/* jsxRuntime */.c } }, { frontmatter }, scope);
        const keys = Object.keys(fullScope);
        const values = Object.values(fullScope);
        // now we eval the source code using a function constructor
        // in order for this to work we need to have React, the mdx createElement,
        // and all our components in scope for the function, which is the case here
        // we pass the names (via keys) in as the function's args, and execute the
        // function with the actual values.
        const hydrateFn = Reflect.construct(Function, keys.concat(`${compiledSource}`));
        return hydrateFn.apply(hydrateFn, values).default;
    }, [scope, compiledSource]);
    if (!isReadyToRender) {
        // If we're not ready to render, return an empty div to preserve SSR'd markup
        return (react.createElement("div", { dangerouslySetInnerHTML: { __html: '' }, suppressHydrationWarning: true }));
    }
    // wrapping the content with MDXProvider will allow us to customize the standard
    // markdown components (such as "h1" or "a") with the "components" object
    const content = (react.createElement(lib/* MDXProvider */.Zo, { components: components },
        react.createElement(Content, null)));
    // If lazy = true, we need to render a wrapping div to preserve the same markup structure that was SSR'd
    return lazy ? react.createElement("div", null, content) : content;
}




/***/ })

}]);